import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
};

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative pt-28 md:pt-36 pb-24 md:pb-32 overflow-hidden"
    >
      {/* Soft ambient blush */}
      <div aria-hidden className="absolute -top-24 left-1/2 -translate-x-1/2 w-[720px] h-[520px] rounded-full bg-blush blur-3xl opacity-70 pointer-events-none" />

      <motion.div
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        data-testid="beta-banner"
        className="relative mx-auto w-full max-w-sm md:max-w-fit px-6 mb-10 md:mb-14"
      >
        <div className="flex flex-col sm:flex-row items-center gap-2 md:gap-3 py-3 px-4 sm:py-2 sm:pl-4 sm:pr-2 rounded-3xl sm:rounded-full bg-pinkDeep text-white text-xs sm:text-sm md:text-base shadow-sm">
          <span className="inline-flex items-center gap-1.5 md:gap-2 font-medium text-center sm:whitespace-nowrap">
            <span className="inline-block w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-white animate-pulse shrink-0" />
            Launching this September
          </span>
          <button
            data-testid="hero-cta-beta"
            onClick={() => scrollTo("waitlist")}
            className="inline-flex items-center gap-1 py-1.5 px-3 md:px-4 rounded-full bg-white text-pinkDeep text-[11px] sm:text-xs md:text-sm font-semibold whitespace-nowrap hover:bg-white/90 transition-colors"
          >
            Get Early Access →
          </button>
        </div>
      </motion.div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <motion.h1
          {...fadeUp}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          className="font-editorial text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.02] tracking-tight text-foreground"
        >
          Everything for baby.
          <br />
          <span className="italic text-pinkDeep">In minutes.</span>
        </motion.h1>

        <motion.p
          {...fadeUp}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.35 }}
          className="mt-8 max-w-xl mx-auto text-base md:text-lg text-foreground/70 leading-relaxed"
        >
          Mumzo is opening its doors to its first families in Hyderabad, a
          thoughtfully curated world of products for little ones, from
          everyday essentials to the things you didn't know you needed.
        </motion.p>

        <motion.div
          {...fadeUp}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.5 }}
          className="mt-10 flex flex-wrap items-center justify-center gap-3"
        >
          <button
            data-testid="hero-cta-primary"
            onClick={() => scrollTo("waitlist")}
            className="mumzo-btn text-base"
          >
            Get Early Access →
          </button>
          <button
            data-testid="hero-cta-secondary"
            onClick={() => scrollTo("why")}
            className="mumzo-btn-ghost text-sm"
          >
            Why Mumzo?
          </button>
        </motion.div>
      </div>
    </section>
  );
}
